/* eslint-disable max-len */
import React from 'react';

const ESGLogo: React.FC<{
  color: string;
  product: string;
  margin?: string;
  width?: string;
  height?: string;
}> = ({color, product, margin, width, height}) =>
  product === 'ESG' ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? '33px'}
      height={height ?? '32px'}
      viewBox={`0 0 ${width ?? '33'} ${height ?? '32'}`}
      fill="none"
      style={{margin: margin ?? ''}}
    >
      <g clipPath="url(#clip0_12334_17912)">
        <path
          d="M9.32544 13.0781H16.2761C16.6399 14.3541 17.0876 15.9211 17.6528 17.9022C18.3915 20.4877 19.3989 24.0022 20.8372 29.0445H4.7644C6.20267 24.0022 7.21001 20.4933 7.94873 17.9022C8.51397 15.9267 8.96168 14.3541 9.32544 13.0837V13.0781Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.48602 16.0176H17.1044"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.9624 21.4282H21.8781V15.7031H24.5644L28.1628 21.4282L28.2356 29.0393H21.1674"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.8351 24.7812H25.387"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1862 2.96094C17.457 3.13442 14.5524 3.74443 12.6441 4.99801C10.7637 6.23481 9.92985 8.20473 11.7487 10.0068C12.409 10.6615 13.2597 11.0421 14.0544 11.1092C16.2593 11.3051 17.0092 8.80913 17.5521 7.09665C18.039 5.55765 18.4531 3.95709 19.1862 2.96094Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.7487 10.0071C11.7487 10.0071 13.5228 7.2201 16.3545 5.08789"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.521 8.93276L15.2017 8.54102"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8529 7.35795L13.7969 5.125"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.58502 19.6875H11.7991"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12334_17912">
          <rect
            width={'32px'}
            height={'32px'}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : product === 'CA' ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? '33px'}
      height={height ?? '32px'}
      viewBox={`0 0 ${width ?? '33'} ${height ?? '32'}`}
      fill="none"
      style={{margin: margin ?? ''}}
    >
      <g clipPath="url(#clip0_12334_17895)">
        <path
          d="M22.5441 23.4878L16.0915 29.4815C15.1625 30.3433 13.7018 30.2873 12.8456 29.3639L7.24924 23.3367C6.10199 22.0999 6.17474 20.1523 7.40594 19.0051L14.9834 11.9648L22.6672 20.2363C23.5291 21.1653 23.4731 22.6259 22.5497 23.4822L22.5441 23.4878Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.6081 24.64C15.8788 26.2461 13.1702 26.151 11.5584 24.4161C9.95227 22.6869 10.0474 19.9782 11.7823 18.3665C13.5116 16.7603 16.2202 16.8555 17.8319 18.5903C19.4381 20.3196 19.343 23.0282 17.6081 24.64Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0841 11.8691L24.2118 3.39062L26.5678 5.93137L17.4402 14.4099"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.393 5.08006L21.3353 3.944C20.9267 3.50189 20.9491 2.80794 21.3912 2.39941L21.6039 2.19794C22.046 1.7894 22.74 1.81179 23.1485 2.2539L24.2062 3.38996"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2817 20.0293C17.0988 20.9079 17.0484 22.279 16.1698 23.0961"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.4318 6.93332L24.6147 6.05469"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.0998 8.1716L23.2828 7.29297"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.7959 9.43527L21.9788 8.55664"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.464 10.6716L20.6469 9.79297"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.1041 11.8881L19.287 11.0039"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.7721 13.1225L17.9551 12.2383"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12334_17895">
          <rect
            width={'32px'}
            height={'32px'}
            fill={color}
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : product === 'PCF' ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? '33px'}
      height={height ?? '32px'}
      viewBox={`0 0 ${width ?? '33'} ${height ?? '32'}`}
      fill="none"
      style={{margin: margin ?? ''}}
    >
      <g clipPath="url(#clip0_34944_66660)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1102 17.2315C12.1031 18.5485 10.657 19.7787 8.89162 20.8269C9.79294 19.0609 10.2765 16.6304 9.68041 14.8863C8.3775 11.1349 8.3775 9.93531 9.04656 8.01266C9.18272 7.62296 9.31184 7.36708 9.45035 7.22388C9.80952 7.68165 10.1241 8.1676 10.3941 8.67468C10.7016 9.61135 10.4715 10.6325 9.79074 11.3462C9.58984 11.5576 9.74719 11.9002 10.0278 11.9002C10.1147 11.9002 10.1992 11.865 10.2649 11.7969C10.6734 11.3673 10.9528 10.8462 11.0866 10.2921C11.1641 10.5269 11.2345 10.764 11.2979 11.0082C11.8733 13.2465 11.6772 15.6104 10.7321 17.7433C10.636 17.9602 10.8015 18.2034 11.0326 18.2034C11.157 18.2034 11.2767 18.1307 11.3307 18.0086C12.0045 16.4874 12.3191 14.8722 12.2698 13.2477C12.6313 13.6069 12.8872 14.067 12.9975 14.5718C13.0375 14.7497 13.2119 14.8568 13.3872 14.8206C13.5633 14.783 13.676 14.6093 13.6361 14.4332C13.4506 13.5811 12.9341 12.8346 12.2064 12.3603C11.9969 10.4747 11.305 8.66364 10.1992 7.13232C10.2931 7.16285 10.3964 7.20275 10.5091 7.25204C13.1971 8.45869 14.7112 10.3978 14.7723 12.7125C14.8122 14.1985 14.237 15.7596 13.1102 17.2315ZM14.1995 9.24513C13.3989 8.18638 12.2463 7.31543 10.7767 6.65577C10.2133 6.40458 9.78135 6.34823 9.41983 6.47735L9.35879 6.50083C8.86346 6.7168 8.60991 7.27787 8.42916 7.79903C7.66384 9.9987 7.78826 11.4307 9.06299 15.0976C9.76022 17.1705 8.72495 20.2388 7.67794 21.5245C7.45382 21.7982 7.76938 22.1802 8.07937 22.0215C10.441 20.8078 12.359 19.288 13.629 17.6283C14.8497 16.0366 15.4695 14.3323 15.4249 12.6961C15.392 11.4401 14.9789 10.2804 14.1995 9.24513ZM11.5232 3.69783C11.9685 2.93465 12.9342 2.68097 13.6924 3.11799C14.4507 3.55464 14.7136 4.52888 14.2746 5.28713C13.8379 6.0454 12.8637 6.30598 12.1054 5.86933C11.3434 5.42906 11.0874 4.45816 11.5232 3.69783ZM11.7791 6.43509C10.7036 5.8122 10.3398 4.43967 10.9575 3.37152C11.576 2.3019 12.9443 1.92922 14.021 2.55222C15.0892 3.16963 15.4578 4.54296 14.8403 5.61345C14.2159 6.69451 12.8408 7.04379 11.7791 6.43509ZM15.2019 7.09946C15.6739 6.27199 16.9379 6.41323 17.195 7.36238C17.2724 7.64409 17.2325 7.93754 17.087 8.18873C16.7865 8.70754 16.1198 8.8883 15.5986 8.58781C15.0798 8.28733 14.9014 7.61826 15.2019 7.09946ZM14.6361 6.77314C13.9645 7.93299 14.8095 9.38599 16.1409 9.38599C17.2858 9.38599 18.1248 8.30289 17.8265 7.19336C17.7067 6.74263 17.418 6.36702 17.0142 6.13461C16.1832 5.65335 15.115 5.93976 14.6361 6.77314ZM18.0307 11.3908C17.8405 11.7218 17.418 11.8345 17.087 11.6443C16.5557 11.3381 16.6613 10.5367 17.2537 10.379C17.8468 10.2211 18.3376 10.8604 18.0307 11.3908ZM18.1035 9.88132C17.4637 9.51299 16.6422 9.72707 16.27 10.3743C15.7536 11.2723 16.4028 12.3885 17.4297 12.3885C17.8945 12.3885 18.3476 12.1491 18.5965 11.7171C18.9674 11.0762 18.7467 10.2522 18.1035 9.88132ZM17.5471 14.1304C17.3928 14.3927 16.994 14.3468 16.9109 14.0459C16.8306 13.7552 17.1494 13.5003 17.4203 13.6562C17.5847 13.7525 17.641 13.9637 17.5471 14.1304ZM17.7466 13.0904C16.9761 12.6468 16.05 13.3594 16.2794 14.2149C16.5104 15.0762 17.6701 15.2233 18.1129 14.4567C18.3875 13.9778 18.2232 13.3651 17.7466 13.0904ZM16.5329 16.2174C16.4179 16.413 16.1266 16.2405 16.2372 16.046C16.2813 15.9683 16.3877 15.9356 16.4696 15.985C16.5517 16.0319 16.5799 16.1352 16.5329 16.2174ZM16.7982 15.4192C17.1936 15.6486 17.3253 16.1532 17.0987 16.5437C16.7285 17.1817 15.7798 17.0503 15.5892 16.3465C15.3999 15.6471 16.1584 15.0498 16.7982 15.4192ZM7.8047 18.7504C7.37509 20.0299 6.50415 21.0771 5.33271 21.7283C4.79277 20.5029 4.72939 19.1425 5.15899 17.8607C5.5886 16.5813 6.46189 15.5343 7.63098 14.884C8.17326 16.1094 8.23666 17.4687 7.8047 18.7504ZM8.07232 14.29C7.99016 14.1328 7.80001 14.067 7.64037 14.1445C6.16141 14.8535 5.0604 16.1 4.53924 17.6541C4.01808 19.2059 4.14485 20.8646 4.89372 22.3222C4.97645 22.4822 5.16894 22.5434 5.32568 22.4678C6.80229 21.7574 7.9033 20.5111 8.42446 18.957C8.94562 17.4053 8.8212 15.7479 8.07232 14.29Z"
          fill="#101223"
          stroke={color}
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_34944_66660">
          <rect width={width ?? '33px'} height={height ?? '32px'} />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? '33px'}
      height={height ?? '32px'}
      viewBox={`0 0 ${width ?? '33'} ${height ?? '32'}`}
      fill="none"
      style={{margin: margin ?? ''}}
    >
      <g clipPath="url(#clip0_12334_17926)">
        <path
          d="M20.2552 21.8538L20.2944 27.3662C20.2944 27.8083 19.9362 28.1721 19.4941 28.1777L14.1216 28.2168C13.6795 28.2168 13.3157 27.8587 13.3101 27.4166L13.2709 21.9209C13.0303 20.9416 11.7711 19.5201 11.7711 19.5201C10.6126 18.3057 9.89631 16.6603 9.87953 14.8527C9.85154 11.0808 12.8904 8.00277 16.6623 7.97479C19.7795 7.9524 22.4266 10.0231 23.266 12.8716"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.2989 25.3961L20.2776 25.3457"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.358 28.1875C18.3636 29.0437 17.6753 29.7377 16.819 29.7489C15.9628 29.7545 15.2688 29.0661 15.2576 28.2099L18.3524 28.1875H18.358Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.7798 20.8906L16.7966 23.4985"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.89 20.041L16.7854 20.9252"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.6584 20.0293L16.7686 20.9303"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6119 2.5293L16.6343 5.15399"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.266 2.25391L21.2793 6.34485"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.719 6.66602L24.1782 8.88777"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.86273 2.3457L11.9054 6.41426"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.47131 6.80469L9.04004 8.98727"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.26459 11.9375L7.52342 12.7434"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.89313 18.1667L7.88158 17.4336"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.415 12.7422H23.2772L23.0086 13.7999C22.74 13.8838 22.4825 13.9902 22.2363 14.1189L21.3017 13.5649L19.7907 15.0759L20.3447 16.0105C20.216 16.2567 20.1097 16.5141 20.0257 16.7828L18.968 17.0514V19.1892L20.0257 19.4578C20.1097 19.7264 20.216 19.9839 20.3447 20.2301L19.7907 21.1647L21.3017 22.6757L22.2363 22.1217C22.4825 22.2504 22.74 22.3567 23.0086 22.4407L23.2772 23.4984H25.415L25.6837 22.4407C25.9523 22.3567 26.2097 22.2504 26.456 22.1217L27.3905 22.6757L28.9016 21.1647L28.3475 20.2301C28.4762 19.9839 28.5826 19.7264 28.6665 19.4578L29.7242 19.1892V17.0514L28.6665 16.7828C28.5826 16.5141 28.4762 16.2567 28.3475 16.0105L28.9016 15.0759L27.3905 13.5649L26.456 14.1189C26.2097 13.9902 25.9523 13.8838 25.6837 13.7999L25.415 12.7422Z"
          stroke={color}
          strokeWidth="0.98"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3573 20.4986C25.6725 20.4986 26.7414 19.4297 26.7414 18.1145C26.7414 16.7994 25.6725 15.7305 24.3573 15.7305C23.0422 15.7305 21.9733 16.7938 21.9733 18.1145C21.9733 19.4353 23.0366 20.4986 24.3573 20.4986Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12334_17926">
          <rect
            width={'32px'}
            height={'32px'}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );

export default ESGLogo;
